<script setup lang="ts">
import { ChevronDownIcon, ClockIcon, Squares2X2Icon } from 'tir-style-system/icons/outline';
import { TirPmButton, TirPmButtonVariantEnum, TirPmButtonSizeEnum } from 'tir-components';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import MonitoringMenuItem from './monitoring-menu-item.vue';
import { MonitoringItemModel } from '../../models';
import { CalendarDaysIcon, TicketIcon } from 'tir-style-system/icons/outline';
import { useRouter } from 'vue-router';
import { MonitoringPagesEnum } from '../../../../pages/monitorings/enums';

const props = defineProps({
  /** Открыто ли меню */
  isSidebarOpen: { type: Boolean },
  /** Показывать только иконки */
  showOnlyIcons: { type: Boolean },
});

const router = useRouter();

/**Находимся ли мы на старницах мониторинга */
const isMonitoringPage = computed(() =>
  Object.values(MonitoringPagesEnum).includes(
    router.currentRoute.value.name as MonitoringPagesEnum,
  ),
);

/**Открыто ли подменю блока мониторинга */
const isSubmenuOpen = ref(false);

/**Выбранный элемент меню мониторинга */
const selectedMonitoringElement = ref();

/**Пункты мониторинга */
const monitoringItems: Array<MonitoringItemModel> = [
  { Id: Date.now(), Title: 'По дням', Icon: CalendarDaysIcon, NameRouter: 'monitoring-days' },
  { Id: Date.now(), Title: 'По тикетам', Icon: TicketIcon, NameRouter: 'monitoring-tickets' },
  // { Id: Date.now(), Title: 'По проектам', Icon: Squares2X2Icon, NameRouter: 'monitoring-projects' },
];

/**Открыть подменю блока мониторинга  */
const toggleSubmenu = () => {
  isSubmenuOpen.value = !isSubmenuOpen.value;
};

watch(
  () => router.currentRoute.value.path,
  () => {
    if (isMonitoringPage.value) {
      selectedMonitoringElement.value = router.currentRoute.value.name;
      isSubmenuOpen.value = true;
    } else {
      selectedMonitoringElement.value = null;
    }
  },
  { immediate: true },
);
</script>

<template>
  <div class="monitoring-menu__block">
    <div
      class="monitoring-menu__content"
      :class="{ 'monitoring-menu__content--close': !isSidebarOpen }"
      @dblclick="toggleSubmenu"
    >
      <div
        :class="{ 'monitoring-menu__title-block--open': isSidebarOpen && !showOnlyIcons }"
        class="monitoring-menu__title-block"
      >
        <ClockIcon class="monitoring-menu__icon" />
        <div
          class="monitoring-menu__title"
          :class="{ 'monitoring-menu__title_visible': isSidebarOpen && !showOnlyIcons }"
        >
          Мониторинг
        </div>
        <TirPmButton
          class="monitoring-menu__chevron-button"
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          v-if="isSidebarOpen"
        >
          <template #leftSlot>
            <ChevronDownIcon
              class="monitoring-menu__chevron-icon"
              :class="{ 'monitoring-menu__submenu-open': isSubmenuOpen }"
              @click="toggleSubmenu"
            />
          </template>
        </TirPmButton>
      </div>
    </div>
    <div v-if="isSubmenuOpen">
      <MonitoringMenuItem
        v-for="item in monitoringItems"
        :active="selectedMonitoringElement === item.NameRouter"
        :key="item.Id"
        :menuItem="item"
        :isSidebarOpen="isSidebarOpen"
        :showOnlyIcons="showOnlyIcons"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.monitoring-menu {
  &__chevron-button {
    width: 1.5rem;
    height: 1.5rem;
  }
  &__chevron-icon {
    width: 1rem;
    min-width: 1rem;
    height: 1rem;
    rotate: 0deg;
    transition: 0.3s rotate;
  }
  &__block {
    margin-bottom: 0.5rem;
  }
  &__content {
    user-select: none;
    &--close {
      width: max-content;
    }
    &:hover {
      background-color: rgba(39, 45, 55, 0.05);
      transition: background-color 0.2s;
      border-radius: 0.375rem;
    }
  }
  &__title-block {
    display: flex;
    align-items: center;
    gap: 0.125rem;
    padding: 0.25rem;
    transition: padding 0.2s;
    cursor: pointer;
    margin-bottom: 0.5rem;
  }
  &__title-block--open {
    padding: 0.25rem 0.375rem 0.25rem 0.75rem;
    transition: padding 0.2s;
  }
  &__title {
    width: 0;
    opacity: 0;
    height: 1.5rem;
    transform: translateX(-10%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: width 0s, opacity 0s, transform 0s, height 0s;
    font-size: 0.875rem;
    font-weight: 500;
  }
  &__title_visible {
    width: 100%;
    opacity: 1;
    height: fit-content;
    transform: translateX(0);
    color: var(--text-primary, #272d37);
    transition: width 0.3s ease, opacity 0.2s ease 0.3s, transform 0.2s ease 0.3s,
      height 0s ease 0.3s;
  }
  &__icon {
    width: 1.5rem;
    min-width: 1.5rem;
    height: 1.5rem;
    padding: 0.125rem;
  }
  &__submenu-open {
    rotate: 180deg;
    transition: 0.3s rotate;
  }
}
</style>
